/**
 * @summary Utility to decode escaped HTML entities within a string.
 */

const slave = document.createElement( 'textarea' );

/**
 * @summary Decodes entities within a string.
 *
 * @param {string} string The string to decode.
 * @return {string} The decoded string.
 */
export default ( string ) => {
	slave.innerHTML = string;
	return slave.value;
};



// WEBPACK FOOTER //
// ./src/js/html-decode.js